import * as types from "../actions/types/futureScheduledPayment.types";

const initialState = {
  dataState: "loading",
  paymentHistoryState: "loading",
  paymentDeleteState: "initial",
  retryPaymentState: "initial",
  futurePayments: {},
  paymentHistory: [],
  hasError: false,
  errorMessage: "",
};

export const futureScheduledPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STARTED: {
      return {
        ...initialState,
      };
    }

    case types.GET_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED: {
      return {
        ...state,
        futurePayments: { ...action.payload },
        dataState: "success",
        errorModal: false,
      };
    }

    case types.GET_FUTURE_SCHEDULED_PAYMENTS_FAILED:
      return {
        ...state,
        dataState: "failed",
        errorMessage: action.payload.message,
      };

    case types.CANCEL_FUTURE_SCHEDULED_PAYMENTS_SUCCEEDED:
      return {
        ...state,
        paymentDeleteState: "success",
      };

    case types.DELETE_PAYMENT_SCHEDULE_SUCCEEDED:
      return {
        ...state,
        paymentDeleteState: "success",
      };

    case types.CANCEL_FUTURE_SCHEDULED_PAYMENTS_FAILED:
      return {
        ...state,
        paymentDeleteState: "failed",
        hasError: true,
        errorMessage: action.payload.message,
      };

    case types.DELETE_PAYMENT_SCHEDULE_FAILED:
      return {
        ...state,
        paymentDeleteState: "failed",
        hasError: true,
        errorMessage: action.payload.message,
      };

    case types.GET_PAYMENTS_HISTORY_SUCCEEDED:
      return {
        ...state,
        paymentHistory: [...action.payload],
        paymentHistoryState: "success",
      };

    case types.GET_PAYMENTS_HISTORY_FAILED: {
      return {
        ...state,
        paymentHistoryState: "failed",
        hasError: true,
        errorMessage: action.payload.message,
      };
    }

    case types.RETRY_PAYMENT_SCHEDULE_SUCCEEDED: {
      return {
        ...state,
        retryPaymentState: "success",
      };
    }

    case types.RETRY_PAYMENT_SCHEDULE_FAILED: {
      return {
        ...state,
        retryPaymentState: "failed",
        hasError: true,
        errorMessage: action.payload.message,
      };
    }

    case types.RESET_RETRY_PAYMENT_SCHEDULE_STATE:
      return {
        ...state,
        retryPaymentState: "initial",
      };

    case types.RESET_PAYMENT_DELETE_STATE:
      return {
        ...state,
        paymentDeleteState: "initial",
      };

    case types.RESET_ERROR_STATUS:
      return {
        ...state,
        hasError: false,
        errorMessage: "",
      };

    default:
      return state;
  }
};
